import { Button, Container, Paper, Typography } from "@mui/material";
import { useUserContext } from "../../hooks/use-auth-context";
import logo from "../../assets/logo.png";
import { ViewContainer } from "../../components/view-container";
import LockResetIcon from "@mui/icons-material/LockReset";
import { Link } from "react-router";
import { Views } from "../../utils/types";
import { contentMaxWidth } from "../../utils/colors";

export const ProfileView = () => {
  const { user } = useUserContext();
  return (
    <ViewContainer
      sx={{
        width: "100%",
        minHeight: "100vh",
        p: 1,
      }}
      className="profile-view"
    >
      <Container maxWidth={contentMaxWidth.form} sx={{ pt: 3 }}>
        <img
          style={{ width: 260, height: "auto" }}
          src={logo}
          alt="school manager logo"
        />
        <Typography variant="h4" component="h4">
          My Profile
        </Typography>
        <Paper sx={{ p: 2, mt: 2 }}>
          <Typography variant="h6">
            {user?.firstName} {user?.lastName}
          </Typography>
          <Typography variant="body1">
            <b>Email:</b> {user?.email}
          </Typography>
          <Typography variant="body1">
            <b>User Role:</b> {user?.role}
          </Typography>
          <Button
            variant="outlined"
            startIcon={<LockResetIcon />}
            component={Link}
            to={Views.RESET_PASSWORD}
            sx={{ mt: 2 }}
          >
            Reset Password
          </Button>
        </Paper>
        <Typography variant="h4" component="h4" sx={{ mt: 4 }}>
          Assigned Devices
        </Typography>
        <Paper sx={{ p: 2, mt: 2 }}>
          <Typography variant="caption">
            No assets linked to your account.
          </Typography>
        </Paper>
      </Container>
    </ViewContainer>
  );
};
